import store from '@/store'

import { unwatch } from '@/lib/helpers/Vue'

function isPayable ({ account, totalByCurrencies }) {
  const accountState = unwatch(account.currencies)
  totalByCurrencies.forEach(amountAndCurrency => {
    accountState
      .find(c => c.id === amountAndCurrency.currency.id)
      .balance -= amountAndCurrency.amount
  })
  return accountState.every(accountCurrency => {
    return accountCurrency.postPaid || accountCurrency.balance >= 0
  })
}

function getPricingGroupWithPricesAppliedToAccount (pricingGroupWithPrices) {
  const pricingGroupId = store.state.activityReservations.edited.account.pricingGroupId
  return pricingGroupWithPrices.find(pGP => pGP.pricingGroupId === pricingGroupId) || pricingGroupWithPrices.find(pGP => !pGP.pricingGroupId)
}

export {
  isPayable,
  getPricingGroupWithPricesAppliedToAccount,
}
